<template>
  <div class="login_box">
    <div class="login_box_title">迷你账号登录</div>
    <el-form
      :model="loginForm"
      :rules="loginRules"
      ref="loginForm"
      @keyup.enter.native="handleLogin"
      label-width="36px"
    >
      <el-form-item prop="uin">
        <el-input
          v-model="loginForm.uin"
          class="login_name"
          placeholder="输入您的迷你号"
        >
          <i slot="prefix" class="account"></i>
          <template slot="append" v-if="isCodeLogin">
            <CountDown
              defaultText="获取验证码"
              @click="handleSendCode"
            ></CountDown>
          </template>
        </el-input>
      </el-form-item>
      <!-- 验证码登录 -->
      <el-form-item v-if="isCodeLogin" prop="authcode">
        <el-input
          v-model="loginForm.authcode"
          type="text"
          class="login_pass"
          placeholder="请输入您收到的验证码"
        >
          <i slot="prefix" class="pass"></i>
          <el-tooltip
            placement="bottom-start"
            slot="suffix"
            style="margin-right: 10px"
          >
            <div slot="content">验证码登录：验证码会发送至您的游戏邮箱</div>
            <div class="logo"><i class="el-icon-question"></i></div>
          </el-tooltip>
        </el-input>
      </el-form-item>
      <!-- 密码登录 -->
      <el-form-item v-else prop="pw">
        <el-input
          v-model="loginForm.pw"
          type="password"
          class="login_pass"
          placeholder="输入您的迷你号密码"
        >
          <i slot="prefix" class="pass"></i>
        </el-input>
      </el-form-item>
      <el-form-item class="code-wrap" prop="icode">
        <el-input
          v-model="loginForm.icode"
          type="text"
          class="login_piccode"
          placeholder="请输入图片验证码"
        >
        </el-input>
        <div class="picture-code" @click="updateCode">
          <img :src="codePicture" />
        </div>
      </el-form-item>
      <div class="login-btn">
        <span @click="handleChangeLoginType">{{ loginType }}</span>
      </div>
      <el-form-item>
        <el-button
          v-loading="isLogining"
          type="warning"
          class="login_btn"
          @click="handleLogin"
          :disabled="!isAgree"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
    <div class="login_box_bottom">
      <el-checkbox v-model="isAgree">我已经详细阅读并同意</el-checkbox>
      <el-link
        :underline="false"
        href="https://www.mini1.cn/privacy_policy.html"
        type="primary"
        target="_blank"
        >《隐私政策》</el-link
      >
      和
      <el-link
        :underline="false"
        type="primary"
        target="_blank"
        href="https://mnweb.mini1.cn/activity/docs/mini1_platform_user_protocol_F20210623_final.htm"
        >《迷你平台用户协议》</el-link
      >
    </div>
  </div>
</template>
<script>
import CountDown from './CountDown';
import {
  loginWithPwd,
  getLoginCode,
  // loginCallback,
  loginWithCode,
  getPicCode,
  repeatCertify,
} from '@/api/common';
import {
  neatedLoginUserInfo,
  setUserInfoInStorage,
  renameLoginTitle,
  isInGame,
} from '@/utils';
import { encryptPwd } from '@/utils/crypto';
let isFromCreatorbbs = false;
let redirectUrl = location.href.split('?')[1];
if (redirectUrl && ~redirectUrl.indexOf('redirectUrl=')) {
  const _arr = redirectUrl.split('&');
  redirectUrl = _arr
    .filter(val => ~val.indexOf('redirectUrl'))[0]
    .split('=')[1];
  redirectUrl = decodeURIComponent(redirectUrl);
  if (/https:\/\/kfz(-test)?.mini1.cn\/creatorbbs\//.test(redirectUrl)) {
    renameLoginTitle('创作者社区');
    isFromCreatorbbs = true;
  }
} else {
  redirectUrl = null;
}
export default {
  components: {
    CountDown,
  },
  data() {
    return {
      loginForm: {
        uin: '',
        pw: '',
        icode: '',
        authcode: '',
        id: '',
      },
      codePicture: '',
      isAgree: false,
      isCodeLogin: false,
      loginType: '验证码登录',
      isLogining: false,
    };
  },
  computed: {
    // 动态计算规则
    loginRules() {
      let rules = {
        uin: [{ required: true, message: '请输入迷你号' }],
      };
      if (this.isCodeLogin) {
        rules.authcode = [{ required: true, message: '请输入您收到的验证码' }];
        rules.icode = [{ required: true, message: '请输入图片验证码' }];
      } else {
        rules.pw = [{ required: true, message: '请输入密码' }];
        rules.icode = [{ required: true, message: '请输入图片验证码' }];
      }
      return rules;
    },
  },
  mounted() {
    this.updateCode();
  },
  methods: {
    // 切换登录方式
    handleChangeLoginType() {
      this.isCodeLogin = !this.isCodeLogin;
      this.loginType = this.isCodeLogin ? '密码登录' : '验证码登录';

      this.$refs.loginForm.clearValidate();
    },
    // 获取验证码
    async handleSendCode(callback) {
      const { uin, icode, id } = this.loginForm;

      if (!uin) {
        return this.$message.error('请输入迷你号');
      } else if (!icode) {
        return this.$message.error('请输入图片验证码');
      }
      // let res = await getLoginCode({ uin, icode });
      try {
        await getLoginCode({ uin, icode, id });
        this.$message.success('验证码已发送至您的游戏邮箱');
        typeof callback === 'function' && callback();
        this.updateCode();
      } catch (e) {
        this.updateCode();
      }
      // console.log('code', res.code);
      // this.$message.success('验证码已发送至您的游戏邮箱');
      //  typeof callback === 'function' && callback();
    },
    //刷新图片验证码
    async updateCode() {
      const res = await getPicCode();
      let newStr = String(res.data.image);
      // eslint-disable-next-line no-useless-escape
      // newStr.replaceAll('\/', '/');
      // eslint-disable-next-line no-useless-escape
      newStr.replace(new RegExp('\/', 'g'), '/'); //replace部分浏览器不适用
      this.codePicture = 'data:image/png;base64,' + newStr;
      this.loginForm.id = res.data.id;
    },

    // 登录
    async handleLogin() {
      if (!this.isAgree) {
        return this.$message.error(
          '请阅读《隐私政策》和《迷你平台用户协议》并勾选同意',
        );
      }
      // 校验
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;

        try {
          const loginMethod = this.isCodeLogin ? loginWithCode : loginWithPwd;
          const { uin, pw, authcode, icode, id } = this.loginForm;
          let params = { uin, icode, id };
          // 如果是密码登录，需要加密
          if (this.isCodeLogin) {
            params.authcode = authcode;
          } else {
            params.pw = encryptPwd(pw);
          }
          //sessionStorage.clear();
          this.isLogining = true;
          const { data } = await loginMethod(params);
          // loginCallback();
          this.isLogining = false;
          // 存储用户信息
          const userInfo = setUserInfoInStorage(neatedLoginUserInfo(data));
          window.MiniService.UserService.init(isInGame ? 1 : 2, userInfo);
          sessionStorage.removeItem('setible');
          sessionStorage.removeItem('token2');
          // 判断是否需要回跳页面
          const Reg = new RegExp(/^https:\/\/kfz(-test)?\.mini1\.cn/);
          if (redirectUrl) {
            if (Reg.test(redirectUrl)) {
              if (isFromCreatorbbs) {
                const isTest =
                  redirectUrl.indexOf('-test.') !== -1 ? '-test' : '';
                const stateUrl = `https://kfz${isTest}.mini1.cn/creatorbbs/#/`;
                history.replaceState(null, '', stateUrl);
                location.href = redirectUrl;
                return location.reload();
              } else {
                location.href = redirectUrl;
              }
            } else {
              return console.warn('仅支持同源认证');
            }
          }
          //判断是否设置独立密码
          let res = await repeatCertify({ uin: this.loginForm.uin });
          //测试
          if (res.code === 500) {
            this.$router.push({
              name: 'Certify',
              params: { uin: this.loginForm.uin },
            });
          }
          // 跳转到首页
          else if (res.code === 0) {
            this.$router.push('/', () => location.reload());
          }
        } catch (err) {
          console.error(err);
          this.isLogining = false;
          this.updateCode();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login_box {
  position: relative;
  top: 201px;
  left: 50%;
  margin-left: -175px;
  width: 350px;
  height: 460px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 8px;
  .el-form-item.code-wrap {
    //  margin-left: 36px !important;
    //width: 282px;
    display: flex;
    margin-bottom: 14px;
    ::v-deep .el-form-item__content {
      display: flex;
      width: 100%;
      height: 45px;
    }
    .el-form-item__content {
      display: flex;
      width: 100%;
      height: 45px;
    }
    .el-input {
      width: 200px;
    }
    .picture-code {
      width: 70px;
    }
    img {
      height: 38px;
      width: 70px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.login_box_bottom {
  position: absolute;
  bottom: 0;
  width: 348px;
  height: 66px;
  background: rgba(243, 248, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  opacity: 1;
  border-radius: 0px 0px 8px 8px;
  padding: 12px 24px;
  font-size: 14px;
  line-height: 24px;
  .el-link {
    color: #2b6ddf;
    &:hover {
      color: #2b6ddf;
    }
  }
}

.login_box_title {
  width: 350px;
  font-size: 20px;
  font-weight: bold;
  color: rgba(38, 38, 38, 1);
  text-align: center;
  margin-top: 40px;
}

.el-input {
  width: 282px;
  height: 40px;
}

.login_name {
  margin-top: 40px;
}

.login-btn {
  text-decoration: none;
  display: block;
  text-align: center;
  color: #2b6ddf;
  font-size: 14px;

  > span {
    cursor: pointer;
    user-select: none;
  }
}

.login_btn {
  width: 282px;
  height: 40px;
  margin-top: 15px;
}

.code {
  cursor: pointer;
  width: 110px;
  color: #fd9b21 !important;
}

.uncode {
  cursor: pointer;
  width: 110px;
  color: #bfbfbf !important;
}

.account {
  background: url('~@/assets/images/ico_account.svg') no-repeat;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: block;
  margin-top: 11px;
}

.pass {
  background: url('~@/assets/images/ico_password.svg') no-repeat;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: block;
  margin-top: 11px;
}
@media screen and (max-width: 980px) {
  .login_box {
    position: relative;
    top: 17%;
    left: 50%;
    margin-left: -160px;
    width: 320px;
    height: 455px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 8px;
    ::v-deep.el-form-item__content {
      margin-left: 18px !important;
    }
  }
  .login_box_bottom {
    position: absolute;
    bottom: 0;
    width: 320px;
    height: 66px;
    background: rgba(243, 248, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    opacity: 1;
    border-radius: 0px 0px 8px 8px;
    padding: 12px 24px;
    font-size: 14px;
    line-height: 24px;
    .el-link {
      color: #2b6ddf;
      &:hover {
        color: #2b6ddf;
      }
    }
  }
  // ::v-deep.el-form-item__content {
  //   display: flex;
  //   width: 100%;
  //   height: 45px;
  // }
}
</style>
